class AIF {
	constructor(_obj) {
		let _email_rx=new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$');
		let _interval=0;
		this._uuid=this.uuidv4();
		this.saver=false;
		this.currentBranch='';
		this.globalData={};
		this.tree=_obj;
		this.history=new Array();
		this.historyCursor = 0;
		this.fromBack = false;
		this.element=document.getElementById(this.tree.dom_element_id);
		this.changeBranch(this.tree.init_branch);
	}
	uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		  var r=Math.random() * 16 | 0, v=c == 'x' ? r : (r & 0x3 | 0x8);
		  return v.toString(16);
		});
	}
	removeElementChilds() {
		while (this.element.lastElementChild) {
			this.element.removeChild(this.element.lastElementChild);
		}
	}
	changeBranch(theBranche) {
		this.removeElementChilds();
		if( this.tree.branches[theBranche] ) {
			if(this.tree.branches[theBranche].saver != undefined) {
				this.saver=true;
			}
			// console.log(this.tree.branches[theBranche].saver, this.saver);
			this.currentBranch=theBranche;
			let _theBranche=this.tree.branches[theBranche];
			let _cp=`aif_${_theBranche.type}`;
			if (this[_cp] && typeof this[_cp] === 'function') {
				if(_theBranche.type != 'link') {
					let _elem=this._createCustomElement('div',{class:`branch_${theBranche}`, id:'branch'},[this[_cp](_theBranche)]);
					_elem.dataset.type=_theBranche.type;
					this.element.appendChild( _elem );
				} else {
					window.location.href=_theBranche.cta+'&'+(new URLSearchParams(this.globalData).toString());
				}
			}
			if(this.saver) {
				let _ft=new FormData();
				let _strObj=`{"data":${JSON.stringify(this.history)}}`;
				_ft.append('uuid', this._uuid);
				_ft.append('nombre', this.globalData.fname);
				_ft.append('apellido', this.globalData.lname);
				_ft.append('email', this.globalData.email);
				_ft.append('phone', this.globalData.phone);
				_ft.append('docid', this.globalData.docid);
				_ft.append('path', _strObj);
				for (var value of _ft.values()) {
					console.log(value);
				}
				fetch('api/', {
					method: "POST",
					body: _ft
				}).then( (data) => data ).then(
					(_dr) => console.log(_dr.text())
				).catch( (_e) => console.log(_e) );
			}
		} else {
			this.element.appendChild(
				this._createCustomElement('div',{},[
					this._createCustomElement('h3',{},['Error']),
					this._createCustomElement('p',{},[`La rama "<em>${theBranche}</em>" no existe en el json.`])
				])
			);
		}
	}
	outBranch(nxt, _q, _a) {
		// nxt: slug del siguiente branch (string)
		// _q: pregunta actual (string)
		// _a: Respuesta (string)
		let _allGood = true;
		if(document.getElementsByTagName('input').length > 0) {
			const toFor = document.getElementsByTagName('input');
			for(let i = 0; i < toFor.length; i++) {
				if(toFor[i].value == '') {
					_allGood = false;
				}
			}
		}
		if(!_allGood) {
			alert('Debe llenar todos los campos');
			return _allGood;
		}
		if(!this.fromBack) {
			this.historyCursor = this.history.length;
		} else {
			this.historyCursor -= 1;
		}
		// console.log(this.historyCursor);
		if(this.tree.branches[this.currentBranch].type == 'input') {
			document.querySelectorAll('input').forEach( _x => {
				this.globalData[_x.name.toString()]=_x.value.toString();
			} );
			
		}
		if(!this.fromBack) {
			this.history.push({_branch: this.currentBranch, _question: _q, _answer: _a, _dt: Date.now()});
		}
		document.querySelector('.branch-in').classList.add('branch-out');
		this._interval=setTimeout(() => {
			this.changeBranch(nxt);
		}, this.tree.transition);
		this.fromBack = false;
	}
	goBack() {
		this.fromBack = true;
		// console.log(this.historyCursor);
		this.outBranch(
			this.history[this.historyCursor]._branch,
			this.tree.branches[this.currentBranch].body, 
			'-- ATRÁS --'
		);
	}
	aif_track(obj) {
		let _ft=new FormData();
		let _strObj=`{"data":${JSON.stringify(this.history)}}`;
		_ft.append('nombre', this.globalData.fname);
		_ft.append('apellido', this.globalData.lname);
		_ft.append('email', this.globalData.email);
		_ft.append('phone', this.globalData.phone);
		_ft.append('docid', this.globalData.docid);
		_ft.append('path', _strObj);
		fetch('crm/', {
			method: "POST",
			body: _ft
		});
	}
	aif_link(obj) {
		//console.table(obj);
		window.location.href=obj.cta+'?fname='+this.globalData.fname+'&lname='+this.globalData.lname+'&email='+this.globalData.email+'&phone='+this.globalData.phone+'&docid='+this.globalData.docid;
	}
	aif_text(obj) {
		let _back = this._createCustomElement('button',{class: 'back-btn'},['Atrás']);
		if(this.historyCursor == 0) {
			_back.classList.add('d-none');
		}
		_back.addEventListener('click', () => { this.goBack() }, !1);
		let _cta = this._createCustomElement('button',{},[obj.cta]);
		_cta.addEventListener('click', () => {
			this.outBranch(obj.next,obj.body,obj.cta);
		}, !1);
		return this._createCustomElement('div', {class:"fp-text branch-in"}, [
			eval('`'+obj.body+'`'),
			_back,
			_cta
		]);
	}
	aif_input(obj) {
		let _back = this._createCustomElement('button',{class: 'back-btn'},['Atrás']);
		if(this.historyCursor == 0) {
			_back.classList.add('d-none');
		}
		_back.addEventListener('click', () => { this.goBack() }, !1);
		let _cta = this._createCustomElement('button',{},[obj.cta]);
		_cta.addEventListener('click', () => {
			// this.outBranch(obj.next, obj.body, document.getElementById(this.currentBranch).value);
			this.outBranch(obj.next,obj.body,obj.cta);
		}, !1);
		return this._createCustomElement('div', {class:"fp-text branch-in"}, [
			eval('`'+obj.body+'`'),
			_back,
			_cta
		]);
	}
	aif_select(obj) {
		let _back = this._createCustomElement('button',{class: 'back-btn'},['Atrás']);
		if(this.historyCursor == 0) {
			_back.classList.add('d-none');
		}
		_back.addEventListener('click', () => { this.goBack() }, !1);
		let ctas=new Array();
		obj.options.forEach(myEle => {
			// console.table(myEle);
			let _cta = this._createCustomElement('button',{class:'btn-select'},[myEle.cta]);
			_cta.addEventListener('click', () => {
				this.outBranch(myEle.next, obj.body,myEle.cta);
			}, !1);
			ctas.push(_cta);
		});
		return this._createCustomElement('div', {class:"fp-select branch-in"}, [
			eval('`'+obj.body+'`'),
			this._createCustomElement('div',{},ctas),
			_back
		]);
	}
	_createCustomElement(element,attributes={},children=[]) {
		let customElement=document.createElement(element);
		if (children !== undefined) {
			children.forEach(el => {
				if (el.nodeType !== undefined) {
					if (el.nodeType === 1 || el.nodeType === 11) {
						customElement.appendChild(el);
					}
				} else {
					customElement.innerHTML += el;
				}
			});
		}
		this._addAttributes(customElement,attributes);
		return customElement;
	}
	_addAttributes(element, attrObj) {
		for (var attr in attrObj) {
			if (attrObj.hasOwnProperty(attr)) {
				element.setAttribute(attr,attrObj[attr]);
			}
		}
	}
}
